import API from "../../modules/base/API";

export const fetching = function (fetching) {
    return {
        type: "FETCH_TESTS",
        payload: fetching,
    }
}

export const fetched = function (tests) {
    return {
        type: "RECEIVE_TESTS",
        payload: tests,
    }
}

export const error = function (error) {
    return {
        type: "FETCH_TESTS_ERROR",
        payload: error,
    }
}

let api = new API({
    get_tests: "/test/list?limit_from=:from&limit_max=:to&brand=:brand",
    delete_test: "/test/delete/:test"
});

export function fetch(from, to, brand) {
    return (dispatch) => {

        dispatch(fetching(true));

        api.request({
            cache: true,
            route: "get_tests",
            params: { from, to, brand },
            success: (response) => {
                dispatch(fetched(response));
            },
            failure: (response) => {
                dispatch(error(true));
            },
            error: (response) => {
                dispatch(error(true));
            }
        });
    };
}



// WEBPACK FOOTER //
// ./src/redux/creators/tests.js